export const isShipmentDeleted = (shipment) => Boolean(shipment?.is_deleted)

export const isShipmentCancelled = (shipment) =>
  String(shipment?.status || '').toLowerCase() === 'rejected'

export const shipmentStatusLabel = (shipment) =>
  isShipmentCancelled(shipment) ? 'Cancelled' : (shipment?.status || '')

export const shipmentDeletedRowClass = (shipment, extra = '') => {
  const base = extra || ''
  if (!isShipmentDeleted(shipment)) return base
  return `${base} line-through text-gray-400 decoration-gray-500`.trim()
}
